import axios, { AxiosError, AxiosInstance } from 'axios';
import { setupCache } from 'axios-cache-adapter';
import { filterErrorsWhiteList } from './interceptor/errorHandler';
import { axiosMock } from './mocks/axiosMock';

export function axiosInstance(): AxiosInstance {
  const cache = setupCache({
    maxAge: 60 * 60 * 1000,
    exclude: {
      query: false,
      methods: ['post', 'patch', 'put', 'delete', 'get'],
      paths: [],
    },
  });

  const axiosBack = axios.create({
    adapter: cache.adapter,
    baseURL: (window as unknown as WindowWithEnv)._env_.msBffHostname,
    headers: { keyId: (window as unknown as WindowWithEnv)._env_.apimApiKey || '' },
    timeout: 30000,
    timeoutErrorMessage: 'ECONNTIMEOUT',
  });

  axiosBack.interceptors.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      return response;
    },
    function (error: AxiosError) {
      return filterErrorsWhiteList(error);
    },
  );

  return /^true$/i.test((window as unknown as WindowWithEnv)._env_.useMock || 'false') ? axiosMock() : axiosBack;
}
